import {
    GET_ADS,
    AD_ERROR,
    ADD_AD,
    DELETE_AD,
    GET_AD,
    UPDATE_AD,
    AD_LOADING,
    AD_SELECT_PROMO,
    AD_SUBMIT_DATA
} from "../../actions/types";

const initalizeState = {
    ads: [],
    loading: true,
    error: {},
    selectedPromoId: null,
    submitData: null,
    updatedAt: new Date(),
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;

    switch (type) {
        case AD_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_ADS:
            return {
                ...state,
                ads: payload.ads,
                loading: false
            };
        case ADD_AD:
            return {
                ...state,
                ads: [payload.ad, ...state.ads],
                loading: false,
                updatedAt: new Date(),
            };
        case DELETE_AD:
            return {
                ...state,
                ads: state.ads.filter(ad => ad.id !== payload),
                loading: false,
                updatedAt: new Date(),
            };
        case UPDATE_AD:
            let ads = state.ads;
            ads = ads.filter(ad => {
                return ad.id !== payload.ad.id;
            });
            return {
                ...state,
                ads: [payload.ad, ...ads],
                loading: false,
                updatedAt: new Date(),
            };
        case GET_AD:
            return {
                ...state,
                loading: false
            };
        case AD_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        case AD_SELECT_PROMO:
            return {
                ...state,
                selectedPromoId: payload.selectedPromoId
            };
        case AD_SUBMIT_DATA:
            return {
                ...state,
                submitData: payload.submitData
            };
        default:
            return state;
    }
}
